import { activate } from '@/store/module/subscription/action/activate.js';
import { cancel } from '@/store/module/subscription/action/cancel.js';
import { getBySubscriberId } from '@/store/module/subscription/action/getBySubscriberId.js';
import { getProduct } from '@/store/module/subscription/action/getProduct.js';
import { isSubscribed } from '@/store/module/subscription/action/isSubscribed.js';
import { subscribe } from '@/store/module/subscription/action/subscribe.js';

export const actions = {
	activate,
	cancel,
	getBySubscriberId,
	getProduct,
	isSubscribed,
	subscribe
};
